module.exports = __webpack_public_path__ + "54cf98f5/img/arrow-share-icon.00a12c29.svg";